export default __webpack_public_path__ + "static/media/ruby-red-grapefruit.9edfbf5f.png";